<!-- 历史库存记录 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" :showRefresh="true" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform">
                </vSearch>
            </div>
        </div>
        <el-tabs>
            <el-tab-pane label="历史库存列表">
                <div class="page_content_center">
                    <u-table v-if="pageShowData.jurTableVo" :key="$store.state.tableNum" @sort-change="sortChange" size="mini" id="tableData" :data="dataShow" :height="tableHeight" border style="width: 100%" show-summary :summary-method="getSummaries"
                             stripe ref="stockTable" :row-style="rowStyle" :header-cell-style="{ background: '#fff' }" :row-height="35" row-key="index" use-virtual>
                        <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                            <u-table-column show-overflow-tooltip v-if="tableValye.isShow == 1 && fixedFields.indexOf(tableValye.entityField) == -1" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" :min-width="tableValye.fieldWeight" :sortable="tableValye.isSort == 1 ? true : false">
                                <template slot-scope="scope">
                                    <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                    <span v-else-if="tableValye.fieldType == 'formatter'">
                                        <span v-for="(item, index) in JSON.parse(tableValye.formatterContent)" :key="index">
                                            <el-tag size="mini" v-if="item.key == scope.row[tableValye.entityField]">
                                                {{ item.value }}
                                            </el-tag>
                                        </span>
                                    </span>
                                    <span v-else-if="tableValye.isRift == 1">
                                        <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                            scope.row[tableValye.entityField]
                                        }}</a>
                                    </span>
                                    <span v-else>
                                        {{ scope.row[tableValye.entityField] }}
                                    </span>
                                </template>
                            </u-table-column>
                        </template>
                        <u-table-column show-overflow-tooltip label="期初" align="center">
                            <u-table-column show-overflow-tooltip prop="inItCount" label="数量" :sortable="true" min-width="100"></u-table-column>
                            <u-table-column show-overflow-tooltip prop="inItMoney" label="金额" :sortable="true" min-width="100"></u-table-column>
                            <u-table-column show-overflow-tooltip prop="inItPsMoney" label="含税金额" :sortable="true" min-width="100"></u-table-column>
                            <u-table-column show-overflow-tooltip prop="inItPackNum" label="件数" :sortable="true" min-width="100"></u-table-column>
                        </u-table-column>
                        <u-table-column show-overflow-tooltip label="入库" align="center">
                            <template slot="header">
                                <el-tooltip class="item" effect="dark" content="包含（采购订单,采购退货,期初导入,库存报溢,货主调拨入库,移库入库,成本调整入库）" placement="top">
                                    <span>入库<i class="el-icon-question"></i></span>
                                </el-tooltip>
                            </template>
                            <u-table-column show-overflow-tooltip prop="inCount" label="数量" :sortable="true" min-width="100"></u-table-column>
                            <u-table-column show-overflow-tooltip prop="inMoney" label="金额" :sortable="true" min-width="100"></u-table-column>
                            <u-table-column show-overflow-tooltip prop="inPsMoney" label="含税金额" :sortable="true" min-width="100"></u-table-column>
                            <u-table-column show-overflow-tooltip prop="inPackNum" label="件数" :sortable="true" min-width="100"></u-table-column>
                        </u-table-column>
                        <u-table-column show-overflow-tooltip label="出库" align="center">
                            <template slot="header">
                                <el-tooltip class="item" effect="dark" content="包含（销售订单,销售退货,库存报损,货主调拨出库,移库出库,成本调整出库,配送出库,配送退货入库）" placement="top">
                                    <span>出库<i class="el-icon-question"></i></span>
                                </el-tooltip>
                            </template>
                            <u-table-column show-overflow-tooltip prop="outCount" label="数量" :sortable="true" min-width="100"></u-table-column>
                            <u-table-column show-overflow-tooltip prop="outMoney" label="金额" :sortable="true" min-width="100"></u-table-column>
                            <u-table-column show-overflow-tooltip prop="outPsMoney" label="含税金额" :sortable="true" min-width="100"></u-table-column>
                            <u-table-column show-overflow-tooltip prop="outPackNum" label="件数" :sortable="true" min-width="100"></u-table-column>
                        </u-table-column>
                        <u-table-column show-overflow-tooltip label="期末" align="center">
                            <u-table-column show-overflow-tooltip prop="endCount" label="数量" :sortable="true" min-width="100"></u-table-column>
                            <u-table-column show-overflow-tooltip prop="endMoney" label="金额" :sortable="true" min-width="100"></u-table-column>
                            <u-table-column show-overflow-tooltip prop="endPsMoney" label="含税金额" :sortable="true" min-width="100"></u-table-column>
                            <u-table-column show-overflow-tooltip prop="endPackNum" label="件数" :sortable="true" min-width="100"></u-table-column>
                        </u-table-column>
                    </u-table>
                </div>
            </el-tab-pane>
        </el-tabs>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <div class="page_content_bottom">
            <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber" :current-page="currentPage" :page-size="pageSize"
                           :page-sizes="[30, 100, 200, 300, 500, 1000, 1500, 2000]" layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <recordSummary ref="recordSummary"></recordSummary>
       <customDesign ref="customDesign"></customDesign>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import FileSaver from "file-saver";
import {
    exportRecordAdd
} from "@/service/printApi.js";
import XLSX from "xlsx";
export default {
    name: "dataQueryTemplate",
    //import引入的组件需要注入到对象中才能使用
    data() {
        //这里存放数据
        return {
            tableHeight: 0,
            getRequestData: {},
            activeName: "0",
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            selectedDataIndex: 0,
            reportConditionVos: [],
            reportModuleVos: [],
            tabIndex: 0,
            totalPageData: [],
            dataShow: [],
            // 共几页
            pageNum: 1,
            // 每页显示数量
            pageSize: 30,
            // 当前显示页码
            currentPage: 1,
            // 总共多少条数据
            total: 1,
            seId: '',
            seIndex: '',
            sField: '',
            parentSearchData: {},
            seTitle: "",//检索
            DialogVisible: false,
            seWidth: '0',
            numberField: [],//数字类型的数据
            stringField: [],//非数字类型的数据
            fixedFields: ['inItCount', 'inItMoney', 'inItPsMoney', 'inItPackNum', 'inCount', 'inMoney', 'inPsMoney', 'inPackNum', 'outCount', 'outMoney', 'outPsMoney', 'outPackNum', 'endCount', 'endMoney', 'endPsMoney', 'endPackNum'],//固定列字段（期初/入库/出库/期末）
            pageShowData: [],
            buttonList: []
        };
    },
    watch: {},
    //方法集合
    methods: {
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        sortChange(column) {
            var dataList = []
            // 深拷贝当前列表数据
            const arr = JSON.parse(JSON.stringify(this.returnData.list));
            // 检查是否有任何项可以转换为有效数字（排除空字符串）
            const hasValidNumbers = arr.some(item => {
                const value = item[column.prop];
                // 检查值不是空字符串且可以转换为有效数字
                return value !== "" && !isNaN(Number(value));
            });
            var typeList = []
            // 动态获取可排序字段
            if (this.pageShowData.jurTableVo && this.pageShowData.jurTableVo.jurconfigtable) {
                this.pageShowData.jurTableVo.jurconfigtable.forEach(item => {
                    if (item.isSort == 1) {
                        typeList.push({ prop: item.entityField })
                    }
                })
            }
            // 固定字段（期初/入库/出库/期末）
            var fixedSortFields = ['inItCount', 'inItMoney', 'inItPsMoney', 'inItPackNum', 'inCount', 'inMoney', 'inPsMoney', 'inPackNum', 'outCount', 'outMoney', 'outPsMoney', 'outPackNum', 'endCount', 'endMoney', 'endPsMoney', 'endPackNum']
            fixedSortFields.forEach(prop => {
                if (!typeList.find(item => item.prop === prop)) {
                    typeList.push({ prop })
                }
            })
            // 查找匹配的字段类型
            const fieldType = typeList.find(item => item.prop === column.prop);
            if (!fieldType) return;
            if (column.order === 'descending') {
                if (hasValidNumbers) {
                    arr.sort((a, b) => {
                        const valueA = a[column.prop];
                        const valueB = b[column.prop];

                        // 处理空字符串
                        if (valueA === "" && valueB === "") return 0;
                        if (valueA === "") return -1;  // 空字符串排在最后
                        if (valueB === "") return 1;   // 空字符串排在最后

                        // 处理非数字值
                        const numA = Number(valueA);
                        const numB = Number(valueB);

                        if (isNaN(numA) && isNaN(numB)) {
                            // 两个都是非数字，按字符串排序
                            return String(valueB).localeCompare(String(valueA));
                        }
                        if (isNaN(numA)) return 1;  // 非数字排在数字之后
                        if (isNaN(numB)) return -1; // 非数字排在数字之后

                        // 两个都是数字，按数值降序排序
                        return numB - numA;
                    });
                } else {
                    // 没有有效数字，全部按字符串降序排序
                    arr.sort((a, b) => {
                        const valueA = a[column.prop] || "";
                        const valueB = b[column.prop] || "";
                        return String(valueB).localeCompare(String(valueA));
                    });
                }
                dataList = arr;
            } else if (column.order === 'ascending') {
                // 升序排序（从小到大）
                if (hasValidNumbers) {
                    arr.sort((a, b) => {
                        const valueA = a[column.prop];
                        const valueB = b[column.prop];

                        // 处理空字符串
                        if (valueA === "" && valueB === "") return 0;
                        if (valueA === "") return 1;   // 空字符串排在最后
                        if (valueB === "") return -1;  // 空字符串排在最后

                        // 处理非数字值
                        const numA = Number(valueA);
                        const numB = Number(valueB);

                        if (isNaN(numA) && isNaN(numB)) {
                            // 两个都是非数字，按字符串排序
                            return String(valueA).localeCompare(String(valueB));
                        }
                        if (isNaN(numA)) return 1;  // 非数字排在数字之后
                        if (isNaN(numB)) return -1; // 非数字排在数字之后

                        // 两个都是数字，按数值升序排序
                        return numA - numB;
                    });
                } else {
                    // 没有有效数字，全部按字符串升序排序
                    arr.sort((a, b) => {
                        const valueA = a[column.prop] || "";
                        const valueB = b[column.prop] || "";
                        return String(valueA).localeCompare(String(valueB));
                    });
                }
                dataList = arr;
            } else {
                // 重置为原始数据
                dataList = JSON.parse(JSON.stringify(list));
            }
            this.returnData.list = dataList
        },
        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 1:
                    this.export2Excel()
                    break;
                case 2:
                    this.recordSummary()
                    break;
            }
        },
        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path)
            let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
            if (responseData.status == 200) {
                this.pageShowData = responseData.result
                this.getButtonList()
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 1000,true,false)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 1000,true,false)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },
        //记录汇总
        recordSummary() {
            this.numberField = [];//数字类型的数据
            this.stringField = [];//非数字类型的数据
            // 动态字段
            if (this.pageShowData.jurTableVo && this.pageShowData.jurTableVo.jurconfigtable) {
                this.pageShowData.jurTableVo.jurconfigtable.forEach((key) => {
                    if (key.isShow == 0) return
                    if (this.fixedFields.indexOf(key.entityField) > -1) return
                    // 映射属性名以兼容recordSummary组件
                    let mappedKey = {
                        fieldEntity: key.entityField,
                        fieldShow: key.showField,
                        fieldType: key.fieldType,
                        isShow: key.isShow,
                        isTotal: key.isTotal,
                        fieldWeight: key.fieldWeight
                    }
                    if (key.fieldType == 'number') {
                        this.numberField.push(mappedKey)
                        return
                    }
                    this.stringField.push(mappedKey)
                })
            }
            // 固定字段（期初/入库/出库/期末）
            var fixedFieldConfig = [
                { fieldEntity: 'inItCount', fieldShow: '期初数量', fieldType: 'number', isShow: 1, isTotal: 1 },
                { fieldEntity: 'inItMoney', fieldShow: '期初金额', fieldType: 'number', isShow: 1, isTotal: 1 },
                { fieldEntity: 'inItPsMoney', fieldShow: '期初含税金额', fieldType: 'number', isShow: 1, isTotal: 1 },
                { fieldEntity: 'inItPackNum', fieldShow: '期初件数', fieldType: 'number', isShow: 1, isTotal: 1 },
                { fieldEntity: 'inCount', fieldShow: '入库数量', fieldType: 'number', isShow: 1, isTotal: 1 },
                { fieldEntity: 'inMoney', fieldShow: '入库金额', fieldType: 'number', isShow: 1, isTotal: 1 },
                { fieldEntity: 'inPsMoney', fieldShow: '入库含税金额', fieldType: 'number', isShow: 1, isTotal: 1 },
                { fieldEntity: 'inPackNum', fieldShow: '入库件数', fieldType: 'number', isShow: 1, isTotal: 1 },
                { fieldEntity: 'outCount', fieldShow: '出库数量', fieldType: 'number', isShow: 1, isTotal: 1 },
                { fieldEntity: 'outMoney', fieldShow: '出库金额', fieldType: 'number', isShow: 1, isTotal: 1 },
                { fieldEntity: 'outPsMoney', fieldShow: '出库含税金额', fieldType: 'number', isShow: 1, isTotal: 1 },
                { fieldEntity: 'outPackNum', fieldShow: '出库件数', fieldType: 'number', isShow: 1, isTotal: 1 },
                { fieldEntity: 'endCount', fieldShow: '期末数量', fieldType: 'number', isShow: 1, isTotal: 1 },
                { fieldEntity: 'endMoney', fieldShow: '期末金额', fieldType: 'number', isShow: 1, isTotal: 1 },
                { fieldEntity: 'endPsMoney', fieldShow: '期末含税金额', fieldType: 'number', isShow: 1, isTotal: 1 },
                { fieldEntity: 'endPackNum', fieldShow: '期末件数', fieldType: 'number', isShow: 1, isTotal: 1 },
            ]
            fixedFieldConfig.forEach((key) => {
                if (key.isShow == 0) return
                if (key.fieldType == 'number') {
                    this.numberField.push(key)
                    return
                }
                this.stringField.push(key)
            })
            let sendData = {
                numberField: this.numberField,
                stringField: this.stringField,
                list: this.returnData.list,
                rpcName: '历史库存列表'
            }
            this.$refs.recordSummary.openBox(sendData)
        },
        // 选中行底色逻辑
        rowStyle({
            row,
            rowIndex
        }) {
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getWidth(e) {
            // console.log(e);
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.getRequestData[type]
        },
        //获取当天最后时间戳
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1
                this.getRequestData.end = time
            }
        },
        toDetail(orderId) {
            this.$parent.toDetail(orderId);
            //    this.$parent.$parent.$parent.toDetail(orderId)
        },
        //   查询
        searchData() {
            this.currentPage = 1
            this.getDataList()
        },
        //表格数据写入excel
        export2Excel() {
            var listData = this.returnData.list
            this.rpmName = '历史库存记录'; //获取当前导出表格标题
            var nameList = [];
            var fieldList = [];
            // 动态字段
            if (this.pageShowData.jurTableVo && this.pageShowData.jurTableVo.jurconfigtable) {
                this.pageShowData.jurTableVo.jurconfigtable.forEach(item => {
                    if (item.isShow == 1 && this.fixedFields.indexOf(item.entityField) == -1) {
                        nameList.push(item.showField)
                        fieldList.push(item.entityField)
                    }
                })
            }
            // 固定字段（期初/入库/出库/期末）
            var fixedNames = ['期初数量', '期初金额', '期初含税金额', '期初件数', '入库数量', '入库金额', '入库含税金额', '入库件数', '出库数量', '出库金额', '出库含税金额', '出库件数', '期末数量', '期末金额', '期末含税金额', '期末件数'];
            var fixedFieldsExport = ['inItCount', 'inItMoney', 'inItPsMoney', 'inItPackNum', 'inCount', 'inMoney', 'inPsMoney', 'inPackNum', 'outCount', 'outMoney', 'outPsMoney', 'outPackNum', 'endCount', 'endMoney', 'endPsMoney', 'endPackNum'];
            nameList = nameList.concat(fixedNames);
            fieldList = fieldList.concat(fixedFieldsExport);
            // 获取日期字段进行格式转换
            var timeList = [];
            if (this.pageShowData.jurTableVo && this.pageShowData.jurTableVo.jurconfigtable) {
                this.pageShowData.jurTableVo.jurconfigtable.forEach(item => {
                    if (item.fieldType == 'date') {
                        timeList.push(item.entityField)
                    }
                })
            }
            listData.forEach(item => {
                timeList.forEach(key => {
                    if (item[key]) {
                        item[key] = this.$common.getLocalTime(item[key])
                    }
                })
            })
            // 导出业务逻辑 引用封装好的js方法
            require.ensure([], () => {
                const {
                    export_json_to_excel
                } = require("@/assets/excel/Export2Excel");
                //这里使用绝对路径( @表示src文件夹 )，使用@/+存放export2Excel的路径
                const tHeader = nameList; // 导出的excel表头名信息
                const filterVal = fieldList; // 导出的excel表头字段名，需要导出表格字段名
                const list = listData; // 查询的数据list
                // 进行数据json map 格式转换
                const data = this.formatJson(filterVal, list);
                // 调用方法传参      表头名信息 数据  导出的表格名称
                export_json_to_excel(tHeader, data, this.rpmName);
            });
            // 导出次数接口
            var token = sessionStorage.getItem("token");
            let params = {
                exportCount: listData.length,
                featuresName: this.rpmName
            }
            exportRecordAdd(params, token).then((res) => {
                if (res.status === 200) { }
            });
        },
        //格式转换方法
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        determine(columns) {
            // 检查动态字段是否需要合计
            if (this.pageShowData.jurTableVo && this.pageShowData.jurTableVo.jurconfigtable) {
                let field = this.pageShowData.jurTableVo.jurconfigtable.find(item => item.entityField === columns.property)
                if (field && field.isTotal == 1) {
                    return true
                }
            }
            // 固定字段（期初/入库/出库/期末）
            if (this.fixedFields.indexOf(columns.property) > -1) {
                return true
            }
            return false
        },
        //表格求和
        getSummaries(param) {
            const {
                columns,
                data
            } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (this.determine(column)) {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return this.toDecimal(prev + curr);
                            } else {
                                return this.toDecimal(prev)
                            }
                        }, 0);
                        sums[index] = this.$common.getDecimalInfo(3, sums[index])
                    } else {
                        sums[index] = 'N/A';
                    }
                } else {
                    sums[index] = '';
                }
            });
            return [sums];
        },
        toDecimal(x) {
            var f = parseFloat(x);
            if (isNaN(f)) {
                return;
            }
            f = Math.round(x * 100) / 100;
            return f;
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.statisticsQueryStockHistory(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result
                this.total = this.returnData.list.length
                this.$store.state.tableNum = this.$store.state.tableNum ? false : true
                this.calcPageData()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.dataShow = this.totalPageData[val - 1];
        },
        // 切换显示条数
        setDataPageSize(val) {
            this.pageSize = val;
            // 重新计算页数并分组
            this.calcPageData();
        },
        // 前端分页逻辑
        calcPageData() {
            // 计算页数(根据后台数据的条数和每页显示数量算出一共几页,得0时设为1)
            if (this.returnData.list.length > 1) {
                this.pageNum = Math.ceil(this.returnData.list.length / this.pageSize) || 1;
            }
            // 数据分组
            for (let i = 0; i < this.pageNum; i++) {
                // 每一页都是一个数组 形如 [['第一页的数据'],['第二页的数据'],['第三页数据']]
                // 根据每页显示数量 将后台的数据分割到 每一页,假设pageSize为5， 则第一页是1-5条，即slice(0,5)，第二页是6-10条，即slice(5,10)...
                this.totalPageData[i] = this.returnData.list.slice(
                    this.pageSize * i,
                    this.pageSize * (i + 1)
                );
            }
            // 获取到数据后显示第一页内容,数组下标是从0开始的，这里一定要减去1，不然会丢失一组数据
            this.dataShow = this.totalPageData[this.currentPage - 1];
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getPageInfo()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(() => {
            this.tableHeight = this.$common.getTableHeight() - 80
        })
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() - 40 }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.page_content_center {
    overflow-y: auto;
}

.dis {
    display: flex;
    flex-wrap: wrap !important;
}
</style>
